// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range-editor .range-intro {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
}
.range-editor .range-intro h4 {
  margin: 0 0 4px;
  font-size: 1rem;
  color: #0f172a;
}
.range-editor .range-intro p {
  margin: 0;
  max-width: 640px;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #64748b;
}
.range-editor .range-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
}
.range-editor .range-summary .chip {
  display: inline-flex;
  gap: 4px;
  padding: 4px 10px;
  font-size: 0.82rem;
  color: #334155;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}
.range-editor .range-summary .chip strong {
  color: #0f766e;
}
.range-editor .range-summary .chip.free strong {
  color: #64748b;
}
.range-editor .range-row {
  display: grid;
  grid-template-columns: auto minmax(90px, 1fr) auto minmax(90px, 1fr) auto minmax(110px, 1.2fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.range-editor .range-row .range-text {
  font-size: 0.85rem;
  color: #64748b;
}
.range-editor .range-row .p-inputnumber {
  width: 100%;
}
.range-editor .range-issues {
  list-style: none;
  margin: 12px 0 0;
  padding: 10px 14px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
  font-size: 0.83rem;
  color: #92400e;
}
.range-editor .range-issues li + li {
  margin-top: 4px;
}
.range-editor .range-issues i {
  margin-right: 6px;
}
.range-editor .range-actions {
  margin-top: 14px;
}
@media (max-width: 768px) {
  .range-editor .range-row {
    grid-template-columns: auto 1fr auto 1fr;
  }
  .range-editor .range-row .price-label {
    grid-column: 1;
  }
}
/*# sourceMappingURL=rooms-form.component.css.map */`, "",{"version":3,"sources":["webpack://./rooms-form.component.less","webpack://./src/app/rooms/rooms-form/rooms-form.component.less"],"names":[],"mappings":"AAEA;EAEI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;ACFJ;ADJA;EASM,eAAA;EACA,eAAA;EACA,cAAA;ACFN;ADTA;EAeM,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ACHN;ADhBA;EAwBI,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;ACLJ;AD1BA;EAkCM,oBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;ACLN;ADpCA;EA4CQ,cAAA;ACLR;ADQM;EACE,cAAA;ACNR;AD1CA;EAsDI,aAAA;EACA,wGAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;ACTJ;ADrDA;EAiEM,kBAAA;EACA,cAAA;ACTN;ADzDA;EAsEM,WAAA;ACVN;AD5DA;EA2EI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;ACZJ;ADtEA;EAqFM,eAAA;ACZN;ADzEA;EAyFM,iBAAA;ACbN;AD5EA;EA8FI,gBAAA;ACfJ;ADmBA;EACE;IACE,wCAAA;ECjBF;EDgBA;IAII,cAAA;ECjBJ;AACF;AACA,mDAAmD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.range-editor {\n  .range-intro {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 14px;\n\n    h4 {\n      margin: 0 0 4px;\n      font-size: 1rem;\n      color: #0f172a;\n    }\n\n    p {\n      margin: 0;\n      max-width: 640px;\n      font-size: 0.85rem;\n      line-height: 1.5;\n      color: #64748b;\n    }\n  }\n\n  .range-summary {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 14px;\n    padding: 12px 14px;\n    background: #f8fafc;\n    border: 1px dashed #cbd5e1;\n    border-radius: 10px;\n\n    .chip {\n      display: inline-flex;\n      gap: 4px;\n      padding: 4px 10px;\n      font-size: 0.82rem;\n      color: #334155;\n      background: @white;\n      border: 1px solid #e5e7eb;\n      border-radius: 4px;\n\n      strong {\n        color: #0f766e;\n      }\n\n      &.free strong {\n        color: #64748b;\n      }\n    }\n  }\n\n  .range-row {\n    display: grid;\n    grid-template-columns: auto minmax(90px, 1fr) auto minmax(90px, 1fr) auto minmax(110px, 1.2fr) auto auto;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    margin-bottom: 8px;\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n\n    .range-text {\n      font-size: 0.85rem;\n      color: #64748b;\n    }\n\n    .p-inputnumber {\n      width: 100%;\n    }\n  }\n\n  .range-issues {\n    list-style: none;\n    margin: 12px 0 0;\n    padding: 10px 14px;\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n    border-radius: 10px;\n    font-size: 0.83rem;\n    color: #92400e;\n\n    li + li {\n      margin-top: 4px;\n    }\n\n    i {\n      margin-right: 6px;\n    }\n  }\n\n  .range-actions {\n    margin-top: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .range-editor .range-row {\n    grid-template-columns: auto 1fr auto 1fr;\n\n    .price-label {\n      grid-column: 1;\n    }\n  }\n}\n",".range-editor .range-intro {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n.range-editor .range-intro h4 {\n  margin: 0 0 4px;\n  font-size: 1rem;\n  color: #0f172a;\n}\n.range-editor .range-intro p {\n  margin: 0;\n  max-width: 640px;\n  font-size: 0.85rem;\n  line-height: 1.5;\n  color: #64748b;\n}\n.range-editor .range-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 14px;\n  padding: 12px 14px;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 10px;\n}\n.range-editor .range-summary .chip {\n  display: inline-flex;\n  gap: 4px;\n  padding: 4px 10px;\n  font-size: 0.82rem;\n  color: #334155;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n}\n.range-editor .range-summary .chip strong {\n  color: #0f766e;\n}\n.range-editor .range-summary .chip.free strong {\n  color: #64748b;\n}\n.range-editor .range-row {\n  display: grid;\n  grid-template-columns: auto minmax(90px, 1fr) auto minmax(90px, 1fr) auto minmax(110px, 1.2fr) auto auto;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n.range-editor .range-row .range-text {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n.range-editor .range-row .p-inputnumber {\n  width: 100%;\n}\n.range-editor .range-issues {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 10px 14px;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 10px;\n  font-size: 0.83rem;\n  color: #92400e;\n}\n.range-editor .range-issues li + li {\n  margin-top: 4px;\n}\n.range-editor .range-issues i {\n  margin-right: 6px;\n}\n.range-editor .range-actions {\n  margin-top: 14px;\n}\n@media (max-width: 768px) {\n  .range-editor .range-row {\n    grid-template-columns: auto 1fr auto 1fr;\n  }\n  .range-editor .range-row .price-label {\n    grid-column: 1;\n  }\n}\n/*# sourceMappingURL=rooms-form.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
